var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZilappLetter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2359 0.652222L39.1449 35.6473L41.7809 35.669C48.7397 35.6891 54.3387 41.3922 54.2332 48.3504C54.1295 55.1744 48.5685 60.6521 41.7436 60.6522L0.372669 60.6385L17.1 25.2573H12.6476C5.85339 25.2569 0.345703 19.7484 0.345703 12.9541C0.346055 6.16011 5.85359 0.652575 12.6476 0.652222H54.2359ZM5.799 12.9541C5.799 16.7366 8.86515 19.8036 12.6476 19.804H25.71L8.98264 55.1852L41.7436 55.1989C45.5889 55.1988 48.7226 52.1126 48.7812 48.2678C48.8407 44.3472 45.6846 41.1335 41.7636 41.1223H41.7609L30.8677 41.0713L45.9455 6.10552H12.6476C8.86536 6.10587 5.79935 9.17189 5.799 12.9541Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZilappLetter);
export default __webpack_public_path__ + "static/media/zilapp_letter.6e8b6c02b9e6570de3a32528d8e836b9.svg";
export { ForwardRef as ReactComponent };